import React, { useEffect, useState } from 'react';
import Script from 'next/script';
import BlockWrapper from '../BlockWrapper';
import Container from '../../interface/Container';
import { FormWrapper, Title } from './MindBodyWidget.styles';

const MindBodyWidgetBlock = ({ block }) => {
  const [mindBodyCode, setMindBodyCode] = useState(false);

  useEffect(() => {
    setMindBodyCode(
      '<healcode-widget data-type="' +
        block.dataType +
        '" data-widget-partner="' +
        block.widgetPartner +
        '" data-widget-id="' +
        block.widgetId +
        '" data-widget-version="' +
        block.widgetVersion +
        '" />'
    );

    return () => {
      setMindBodyCode('');
    };
  });

  return (
    <BlockWrapper>
      <Container>
        {block.mainTitle && <Title>{block.mainTitle}</Title>}
        <Script
          async src="https://widgets.mindbodyonline.com/javascripts/healcode.js"
          type="text/javascript"
          strategy="afterInteractive"
        />
        <FormWrapper>
          <div dangerouslySetInnerHTML={{ __html: mindBodyCode }} />
        </FormWrapper>
      </Container>
    </BlockWrapper>
  );
};

export default MindBodyWidgetBlock;
